import React from "react";
import { useStoreLocation } from "../hooks/useStoreLocation";

const USSite = ({ children }) => {
  const { storeLocation } = useStoreLocation();

  return <>{storeLocation === "us" && children}</>;
};

export default USSite;
